<template>
  <div style="width:654px;height:860px;display:flex;flex-flow: column;">
    <div class="topImg">
      <img v-if="img" :src="img" alt="" />
      <div class="time">
        <div style="font-size:36px">{{ week }}</div>
        <div class="timeRight">
          <div style="font-size:48px">{{ date }}</div>
          <div style="font-size:28px">{{ mon }}.{{ year }}</div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div style="width: 120px;">
        <tk-image
          class="flex-shrink-0"
          :oraign="true"
          :quality="85"
          :src="
            titleImg
          "
        />
      </div>
      <div style="width: 120px;height: 120px;">
        <tk-image style="width: 120px;height: 120px;" :src="qrImage"></tk-image>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      img: '',
      date: '',
      mon: '',
      week: '',
      year: '',
      titleImg: require('../../../assets/image/zhituo/titleImg.png'),
      qrImage: require('../../../assets/image/zhituo/wxQr.jpg')
    }
  },
  mounted () {
    // 获取当前时间
    console.log(new Date().getMonth())
    console.log(new Date().getDay())
    console.log(new Date().getFullYear())
    let monArr = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Spt',
      'Oct',
      'Nov',
      'Dec'
    ] // 英文月份
    let weeks = [
      '星期日',
      '星期一',
      '星期二',
      '星期三',
      '星期四',
      '星期五',
      '星期六'
    ]
    this.mon = monArr[new Date().getMonth()]
    this.week = weeks[new Date().getDay()]
    this.year = new Date().getFullYear()
    this.date =
      new Date().getDate() > 9
        ? new Date().getDate()
        : '0' + new Date().getDate()
    this.getSetting()
  },
  methods: {
    async getSetting () {
      var rs = await this.$tkParse.get(
        'https://cloud.zhituo.mokekeji.com/settings/share'
      )
      this.img = rs.data
    }
  }
}
</script>

<style>
.topImg {
  width: 654px;
  height: 654px;
  position: relative;
}
.topImg img {
  width: 100%;
  height: 100%;
}
.time {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 30px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  color: #fff;
}
.timeRight div {
  display: flex;
  text-align: right;
}
.bottom {
  flex: 1;
  background: #fff;
  padding: 40px 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
